import { UserData } from '@taxdown/kami-sama/dist/definition';
import { SamaDictionary } from '@taxdown/kami-sama/dist/kamiSama/definition';
import { AnyAction } from 'redux';
import { initialState } from './initialState';

import * as types from './types';

export type UserStateType = {
  forms: SamaDictionary | null;
  userData: UserData | null;
  stage: string | null;
  isLoading: boolean;
};

const reducer = (
  state: UserStateType = initialState,
  action: AnyAction = { type: '' }
): UserStateType => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_IS_LOADING_DATA:
      return {
        ...state,
        isLoading: payload?.isLoading,
      };
    case types.SET_FORM_TYPE:
      return {
        ...state,
        forms: payload?.data,
      };
    case types.SET_USER_DATA_TYPE:
      return {
        ...state,
        userData: payload?.data,
      };
    case types.SET_STAGE_TYPE:
      return {
        ...state,
        stage: payload,
      };
    default:
      return state;
  }
};

export default reducer;
